export const featuredPortfolio = [
	{
		id: 1,
		title: "Blog",
		img: "assets/ftwblog.png",
		src: "https://ftw-blog.vercel.app/",
		git: "https://github.com/FerreiraTiagoWebDev/FTWblog",
		desc: "It was very interesting to create this blog using Next.js. The styling introduced me to Tailwind-Css and the back-end with GraphQL showed me an easier way to fetch content dinamically.",
		desc2:
			"The content of the blog can be created in GraphQL CMS through an user friendly interface. ",
		dep: "Eslint, GraphQL, Lint, Moment, Next, React, React-multi-carousel, Sass, Tailwindcss, Vercel",
	},
	{
		id: 2,
		title: "E-Commerce",
		img: "assets/slit2.png",
		src: "https://slitshop.web.app/",
		git: "https://github.com/FerreiraTiagoWebDev/slit-client",
		desc: "A responsive Clothing Web App using React.js, connected to a backend server.",
		desc2:
			"The database and the connection between front and back-end was created using Node.js, Express and MongoDb.",
		dep: "Front-end: Axios, Redux, React-Router, Styled-Components, Firebase",
		dep2: "Back-end: Express, Nodemon, Mongodb - Atlas - Compass, PostMan, Mongoose, JSONwebtoken, Crypto-js, Dotenv, Heroku  ",
	},
];

export const reactNativePortfolio = [
	{
		id: 3,
		title: "TeslaApp",
		img: "assets/teslaApp.png",
		src: "",
		videoSrc: "assets/teslaVideo.mp4",
		git: "https://github.com/FerreiraTiagoWebDev/teslaApp",
		desc: "A clone of the Tesla App home page where I got introduced to mobile development through the Expo CLI.",
		desc2:
			"Since it is a simple exercise I did not deploy this app and provided just sample video to showcase it.",
		dep: "Expo, React-Native",
	},
	{
		id: 4,
		title: "ShoppingList",
		img: "assets/shoppingApp.png",
		src: "",
		videoSrc: "assets/shoppingVideo.mp4",
		git: "https://github.com/FerreiraTiagoWebDev/ReactNative-ShoppingList",
		desc: "I have decided to tackle the React-Native CLI installation and dive deeper in the mobile development process.",
		desc2:
			"I am hoping to build a more complex App in React-Native soon, something worth deploying to the play store.",
		dep: "React-Native CLI, UUID, Vector-Icons",
	},
];

export const javascriptPortfolio = [
	// {
	//   id: 5,
	//   title: "",
	//   img: "",
	//   src: "",
	//   git: "",
	// },
	{
		id: 6,
		title: " Pacman ",
		img: "assets/pacmanweb.png",
		src: "https://determined-agnesi-9e8bf9.netlify.app/",
		git: "https://github.com/FerreiraTiagoWebDev/pacmanDeploy",
		desc: "A Pacman clone as an exercise in Javascript.",
		desc2: "Eventually modified the grid to my name just for fun.",
		dep: "Javascript, Parcel, Netlify",
	},
];

export const reactPortfolio = [
	{
		id: 7,
		title: "Portfolio",
		img: "assets/portfolioProjectBg.png",
		src: "https://ferreira-tiago.web.app/",
		git: "https://github.com/FerreiraTiagoWebDev/Portfolio",
		desc: "My very own portfolio. It was great fun building it from scratch.",
		desc2:
			"It really improved my problem solving abilities in web development. As well as my resistance to frustration :D",
		dep: "Gsap / i118next/ ityped/ JS-cookie/ React-Icons/ React-Spring/ Emailjs-com / SASS / Styled-Components / Firebase",
	},
	{
		id: 8,
		title: "Pokedex",
		img: "assets/pokedex.png",
		src: "https://ftwebdev-pokedex.web.app/",
		git: "https://github.com/FerreiraTiagoWebDev/react_redux_pokemon_api",
		desc: "An exploration into React Redux",
		desc2:
			"It helped me learn about React's global state, routing, API calls and error handling ",
		dep: "Axios / React Router / Redux / Redux Thunk/ uuid / React Icons/ Lodash / SASS / Styled-Components / Firebase",
	},
	{
		id: 9,
		title: "Quiz App",
		img: "assets/quizapp.jpg",
		src: "https://ferreiratiagoquizzz.web.app/",
		git: "https://github.com/FerreiraTiagoWebDev/QuizzApp",
		desc: "My first project using React.js without following an online tutorial.",
		desc2:
			"It helped me learn a lot about React's fundamentals. Props vs State, Basic Hooks ",
		dep: "Axios / React Router / Material-UI / SASS / Styled-Components / Firebase",
	},
];
export const backEndPortfolio = [
	{
		id: 9,
		title: "E-Commerce",
		img: "assets/slit2.png",
		src: "https://slitshop.web.app/",
		git: "https://github.com/FerreiraTiagoWebDev/slit-client",
		desc: "A responsive Clothing Web App using React.js, connected to a backend server.",
		desc2:
			"The database and the connection between front and back-end was created using Node.js, Express and MongoDb.",
		dep: "Front-end: Axios, Redux, React-Router, Styled-Components, Firebase",
		dep2: "Back-end: Express, Nodemon, Mongodb - Atlas - Compass, PostMan, Mongoose, JSONwebtoken, Crypto-js, Dotenv, Heroku  ",
	},
	{
		id: 10,
		title: "Blog",
		img: "assets/ftwblog.png",
		src: "https://ftw-blog.vercel.app/",
		git: "https://github.com/FerreiraTiagoWebDev/FTWblog",
		desc: "It was very interesting to create this blog using Next.js. The styling introduced me to Tailwind-Css and the back-end with GraphQL showed me an easier way to fetch content dinamically.",
		desc2:
			"The content of the blog can be created in GraphQL CMS through an user friendly interface. ",
		dep: "Eslint, GraphQL, Lint, Moment, Next, React, React-multi-carousel, Sass, Tailwindcss, Vercel",
	},
	{
		id: 11,
		title: "Iframe",
		img: "assets/jaimy.png",
		src: "https://jaimystaging.be/fr/chauffagistes/projet/myindex",
		desc: "Iframe implementation for Jaimy.be",
	},
];
